var AddToCartPopup = (function ($) {

    function findFullyFittedOption(entry) {
        if (!entry || !entry.options || !entry.options.length) {
            return null;
        }

        for (var optionIndex = 0; optionIndex < entry.options.length; optionIndex++) {
            var option = entry.options[optionIndex];
            if (option && option.code === "FULLYFITTED") {
                return option;
            }
        }

        return null;
    }

    function showInformationPopup(cartData, products) {
        var $cartPopUpTmpl = $("#information-popup-tmpl:not(.popup-disabled)");
        var $cartEntryTmpl = $("#information-popup-entry-tmpl:not(.popup-disabled)");
        var $cartPopUpTmplForCart = $("#information-popup-tmpl-for-cart");

        if ($cartPopUpTmplForCart.length) {
            $cartPopUpTmplForCart.hide();
        }

        if (!cartData
            || !cartData.entries
            || !products
            || !products.items
            || !$cartEntryTmpl.length
            || !$cartPopUpTmpl.length){

            return;
        }

        var cartEntriesString = "";

        for (var j = 0; j < products.items.length; j++) {
            var product = products.items[j];

            if(!product.code || !product.quantity){
                continue;
            }

            for (var i = 0; i < cartData.entries.length; i++) {
                var entry = cartData.entries[i];

                if (entry.entryId !== product.code) {
                    continue;
                }

                var productInfo = "";
                for (var k = 0; k < entry.productDescriptions.length; k++) {
                    var productDescription = entry.productDescriptions[k];

                    productInfo += "<div class='product-info-container'>";

                    if (cartData.withDetails && productDescription.image) {
                        productInfo += "<img src='" + productDescription.image + "' alt='' class='product-info-image'>";
                    }

                    productInfo += "<div class='product-info'>";
                    if (productDescription.brand)
                        productInfo += "<p class='product-info-brand'>"+ productDescription.brand+"</p>";
                    if (productDescription.model)
                        productInfo += "<p class='product-info-model'>"+  productDescription.model+"</p>";
                    if (productDescription.sizes)
                        productInfo += "<p class='product-info-size'>"+  productDescription.sizes+"</p>";
                    productInfo += "</div>";
                    productInfo += "</div>";
                }

                var cartEntryString = $cartEntryTmpl.html().trim();
                var fullyFittedOption = findFullyFittedOption(entry);
                var showFullyFittedBreakdown = fullyFittedOption && entry.formattedPricePerUnitWithOptions;
                cartEntryString = cartEntryString.replace("%entry-product-info%", productInfo);
                cartEntryString = cartEntryString.replace("%entry-quantity%", product.quantity);
                cartEntryString = cartEntryString.replace("%entry-price-breakdown-class%", showFullyFittedBreakdown ? "" : "csm-price-breakdown--single");
                cartEntryString = cartEntryString.replace("%entry-base-price-row-class%", showFullyFittedBreakdown ? "hidden" : "");
                cartEntryString = cartEntryString.replace("%entry-base-price%", entry.entryPriceFormatted);
                cartEntryString = cartEntryString.replace("%entry-total-price-row-class%", showFullyFittedBreakdown ? "" : "hidden");
                cartEntryString = cartEntryString.replace("%entry-total-price%", showFullyFittedBreakdown ? entry.formattedPricePerUnitWithOptions : "");
                cartEntryString = cartEntryString.replace("%popup-icon-container%", cartData.withDetails ? "": "hidden");

                cartEntriesString += cartEntryString;

                break;
            }
        }

        if (!cartEntriesString) {
            return;
        }

        var cartEntriesTmplString = $cartPopUpTmpl.html().trim();
        cartEntriesTmplString = cartEntriesTmplString.replace("%entries%", cartEntriesString);
        if (cartData.withServicePartnerDetailsOnSerpPdp) {
            cartEntriesTmplString = cartEntriesTmplString.replace("%information-popup-service-partner%", "");
            cartEntriesTmplString = cartEntriesTmplString.replace("%information-popup-links%", "hidden");
            $("#information-popup-entry-block").hide();
            cartEntriesTmplString = cartEntriesTmplString.replace("%to-cart-page-without-sp%", "");
            if (cartData.servicePartnerAdvantagesList && cartData.servicePartnerAdvantagesList.length > 0) {
                let servicePartnerAdvantages = "";
                servicePartnerAdvantages = '<ul class="service-partners-popup-advantages-list">';
                cartData.servicePartnerAdvantagesList.forEach(advantage => {
                    servicePartnerAdvantages += `<li>${advantage}</li>`;
                });
                servicePartnerAdvantages += '</ul>';
                cartEntriesTmplString = cartEntriesTmplString.replace("%service-partner-advantages-list%", servicePartnerAdvantages);
            }
        } else {
            cartEntriesTmplString = cartEntriesTmplString.replace("%information-popup-links%", "");
            cartEntriesTmplString = cartEntriesTmplString.replace("%information-popup-service-partner%", "hidden");
            cartEntriesTmplString = cartEntriesTmplString.replace("%to-cart-page-without-sp%", "hidden");
            cartEntriesTmplString = cartEntriesTmplString.replace("%service-partner-advantages-list%", "hidden");
        }

        var showTotalprice = products.discountedPrice || products.price;
        cartEntriesTmplString = cartEntriesTmplString.replace("%total-entries-price%", showTotalprice === products.price
            ? '' : products.price);
        cartEntriesTmplString = cartEntriesTmplString.replace("%total-entries-discounted-price%", (showTotalprice && products.discountedPrice)
            ? products.discountedPrice : showTotalprice);
        cartEntriesTmplString = cartEntriesTmplString.replace("%total-entries-price-block%", (!showTotalprice)
            ? 'hidden' : '');

        $.fancybox({
            width: 450,
            autoHeight: true,
            fitToView: true,
            scrolling: 'no',
            content: cartEntriesTmplString,
            autoSize: false,
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });
    }

    function handleAddToCartEvent() {
        $( document ).on( "changeCartEvent", function( event, data) {
            var $cartPopUpTmpl = $("#information-popup-tmpl:not(.popup-disabled)");
            var $cartEntryTmpl = $("#information-popup-entry-tmpl:not(.popup-disabled)");

            if (!$cartEntryTmpl.length
                || !$cartPopUpTmpl.length){

                window.location.href = "/cart";
                return;
            }

            if (!data || !data.items){
                return;
            }

            $.ajax({
                url: "/cart/data",
                type: "GET",
                contentType: 'application/json',
                dataType: 'json',
                success: function(cartData) {
                    showInformationPopup(cartData, data)
                }
            });
        });

    }

    function displayInformationPopupInCartPage() {
        let location = window.location.pathname;
        let displayedPopupAlready = sessionStorage.getItem("popupDisplayed") === "true";

        if (location == "/cart" && !displayedPopupAlready) {
            $(function() {
                var $informationPopUpTmpl = $("#information-popup-tmpl");
                $informationPopUpTmpl.hide();
                var $informationEntryTmpl = $("#information-popup-entry-tmpl");
                $informationEntryTmpl.hide();
                var $templateForCartPagePopUp = $("#information-popup-tmpl-for-cart");

                if (!$templateForCartPagePopUp.length) {
                    return;
                }

                var templateForCartPagePopUpString = $templateForCartPagePopUp.html().trim();

                $.fancybox({
                    width: 450,
                    autoHeight: true,
                    fitToView: true,
                    scrolling: 'no',
                    content: templateForCartPagePopUpString,
                    autoSize: false,
                    autoCenter: false,
                    helpers: {
                        overlay: {
                            locked: false
                        }
                    }
                });
                sessionStorage.setItem("popupDisplayed", "true");
            });
        }
    }

    return {
        showInformationPopup: showInformationPopup,
        handleAddToCartEvent: handleAddToCartEvent,
        displayInformationPopupInCartPage:  displayInformationPopupInCartPage
    };
}) (jQuery);

$(document).ready(function() {
    AddToCartPopup.displayInformationPopupInCartPage();
    AddToCartPopup.handleAddToCartEvent();
});